import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';

import { CoacheeSettingsController } from 'presentation/page/settings/coachee-settings/coachee-settings.controller';

@Component({
	selector: 'spr-settings-information',
	templateUrl: './settings-information.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsInformationComponent implements OnInit {
	public form: FormGroup;
	public birthDateRange: string;
	public timeZoneOptions: SelectItem[];

	constructor(
		public controller: CoacheeSettingsController,
		private _controlContainer: ControlContainer
	) {
		const birthMaxYear = moment().subtract(16, 'year').year();
		const birthMinYear = moment().subtract(90, 'year').year();

		this.timeZoneOptions = moment.tz
			.names()
			.map((name) => ({ label: name, value: name } as SelectItem));
		this.birthDateRange = `${birthMinYear}:${birthMaxYear}`;
	}

	ngOnInit() {
		this.form = this._controlContainer.control as FormGroup;
	}

	public onSaveClick() {
		this.controller.save().subscribe();
	}
}
